import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.math.trunc.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, toRefs, reactive, ref, computed, onActivated, onMounted } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Loading } from "@element-plus/icons";
import Head from "@/components/Head/index.vue";
import { useRouter } from "vue-router";
import "swiper/swiper.scss";
import Swiper from "swiper";
export default defineComponent({
  name: "OnlineStudy",
  components: {
    Head: Head,
    Loading: Loading
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var loading = ref(false);
    var keepStatus = true; //首次进入为缓存状态，但不需要走activited方法

    var PaginationInit = ref(false); // 图片路径前缀

    var baseUrl = process.env.VUE_APP_BASE_URL; // 搜索条件

    var searchValue = reactive({
      pageIndex: 1,
      pageSize: 10,
      draft: 1,
      title: "",
      columnId: 0,
      classificationId: 0
    }); // 切换变化的值

    var switchIdentity = reactive({
      currentTabIndex1: 0,
      currentTabIndex2: 0
    }); // 数据列表信息

    var dataList = reactive({
      listData: [],
      totalNum: 0,
      culumnId: 0
    }); //tabs 分类

    var classification = reactive({
      firstTabs: [],
      secondTabs: []
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getcolumnList();

            case 2:
              _context.next = 4;
              return getTwocolumnList();

            case 4:
              new Swiper('.swiper-container', {
                autoHeight: true,
                slidesPerView: 'auto',
                observer: true
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    onActivated( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!keepStatus) {
                //await getcolumnList();
                //await getTwocolumnList()
                setTimeout(function () {
                  getTabledata();
                }, 200);
              } else {
                keepStatus = false;
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))); //getcolumnList();
    //获取一级栏目列表

    function getcolumnList() {
      return _getcolumnList.apply(this, arguments);
    } //获取二级栏目列表


    function _getcolumnList() {
      _getcolumnList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getcolumnList"]({
                  parentId: 0
                });

              case 2:
                res = _context3.sent;
                classification.firstTabs = res.data;
                dataList.culumnId = res.data[0].columnId;
                switchIdentity.currentTabIndex1 = res.data[0].columnId;
                searchValue.classificationId = res.data[0].columnId; //getTwocolumnList();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getcolumnList.apply(this, arguments);
    }

    function getTwocolumnList() {
      return _getTwocolumnList.apply(this, arguments);
    } // 搜索


    function _getTwocolumnList() {
      _getTwocolumnList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getcolumnList"]({
                  parentId: dataList.culumnId
                });

              case 2:
                res = _context4.sent;
                classification.secondTabs = res.data;
                searchValue.columnId = res.data[0].columnId;
                switchIdentity.currentTabIndex2 = res.data[0].columnId;
                getTabledata();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getTwocolumnList.apply(this, arguments);
    }

    function searchByName() {
      return _searchByName.apply(this, arguments);
    }

    function _searchByName() {
      _searchByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                getTabledata();

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _searchByName.apply(this, arguments);
    }

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 翻页


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dataList.listData = [];
                loading.value = false;
                _context6.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getarticleList"](searchValue);

              case 4:
                res = _context6.sent;

                if (res.code == 0) {
                  dataList.listData = res.data;
                  dataList.totalNum = res.total;
                  loading.value = true;
                  PaginationInit.value = true;
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function changPage(_x) {
      return _changPage.apply(this, arguments);
    } //计算进度


    function _changPage() {
      _changPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(val) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                searchValue.pageIndex = val;
                getTabledata();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _changPage.apply(this, arguments);
    }

    var percent = computed(function () {
      return function (row) {
        if (!row.studyTime) {
          return 0;
        } else {
          var a = Number(((row.studyDuration - row.studyTime) / row.studyDuration).toFixed(2));
          return Math.round(a * 100);
        }
      };
    }); //计算学时

    var conversion = computed(function () {
      return function (seconds, studyDuration) {
        if (!seconds) {
          return 0;
        } else {
          return ((studyDuration - seconds) / 60).toFixed(2);
        }
      };
    }); // 第一行tabs切换

    function getFirstIndex(_x2) {
      return _getFirstIndex.apply(this, arguments);
    } //第二行tabs切换


    function _getFirstIndex() {
      _getFirstIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(index) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                dataList.culumnId = index;
                searchValue.classificationId = index;
                PaginationInit.value = false;
                switchIdentity.currentTabIndex1 = index;
                switchIdentity.currentTabIndex2 = 0;
                searchValue.pageIndex = 1;
                getTwocolumnList();

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _getFirstIndex.apply(this, arguments);
    }

    function getSecondIndex(_x3) {
      return _getSecondIndex.apply(this, arguments);
    } // 跳转详情页


    function _getSecondIndex() {
      _getSecondIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(index) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                PaginationInit.value = false;
                switchIdentity.currentTabIndex2 = index;
                searchValue.pageIndex = 1;
                searchValue.columnId = index;
                getTabledata();

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      return _getSecondIndex.apply(this, arguments);
    }

    function toPage(newsId) {
      router.push({
        name: "StudyDetail",
        query: {
          newsId: newsId
        }
      });
    } //计算时长


    function secTotime(s) {
      var t = "";

      if (s > -1) {
        var min = Math.floor(s / 60);
        var sec = Math.trunc(s % 60);

        if (min < 10) {
          t += "0";
        }

        t += min + ":";

        if (sec < 10) {
          t += "0";
        }

        t += sec.toFixed(0);
      }

      return t;
    } //跳转我的收藏


    function handleClllection() {
      router.push({
        name: "StudyCollection"
      });
    } //跳转我的排行


    function handleRank() {
      router.push({
        name: "StudyRank"
      });
    }

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      baseUrl: baseUrl,
      loading: loading,
      PaginationInit: PaginationInit,
      changPage: changPage,
      getFirstIndex: getFirstIndex,
      getSecondIndex: getSecondIndex
    }, toRefs(dataList)), toRefs(searchValue)), toRefs(switchIdentity)), toRefs(classification)), {}, {
      searchByName: searchByName,
      toPage: toPage,
      handleClllection: handleClllection,
      handleRank: handleRank,
      getcolumnList: getcolumnList,
      percent: percent,
      conversion: conversion,
      secTotime: secTotime,
      keepStatus: keepStatus
    });
  }
});